import { getLink } from "./sideMenuData"
import { fussball, talentwerk, badminton, basketball } from "../code/unsplashImages"
const badmintonSenioren = [
    {
        "team": "1. Mannschaft",
        "liga": "Verbandsliga Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=9",
        "img": '/images/mannschaftssport/badminton/verbandsliga_1mannschaft.jpg',
        "altText": 'Teamfoto, 1.Mannschaft Badminton, Oberpleis'
    },
    {
        "team": "2. Mannschaft",
        "liga": "Landesliga Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=17",
        "img": badminton.path,
        "altText": badminton.altText
    },
    {
        "team": "3. Mannschaft",
        "liga": "Bezirksliga Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=33",
        "img": badminton.path,
        "altText": badminton.altText
    },
    {
        "team": "4. Mannschaft",
        "liga": "Bezirksklasse Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=33",
        "img": badminton.path,
        "altText": badminton.altText
    },
]
const badmintonJunioren = [
    {
        "team": "1. Jugendmannschaft",
        "liga": "Bezirksliga Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=126",
        "img": badminton.path,
        "altText": badminton.altText
    },
    {
        "team": "U15 Mini-Mannschaft",
        "liga": "Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=191",
        "img": badminton.path,
        "altText": badminton.altText
    },
    {
        "team": "U13 Mini-Mannschaft",
        "liga": "Süd 2",
        "link": "https://dbv.turnier.de/sport/league/draw?id=066F2F48-EF43-47A8-999F-A2021BE81D09&draw=195",
        "img": badminton.path,
        "altText": badminton.altText
    },
]

const basketballTeams = [
    {
        "team": "1. Mannschaft Herren",
        "liga": "Kreis Bonn",
        "link": "https://www.basketball-bund.net/static/#/liga/44852/tabelle",
        "img": '/images/mannschaftssport/basketball/Mannschaftsfoto_Herren_2024_basketball.jpg',
        "altText": 'Teamfoto, 1.Mannschaft Basketball, Oberpleis'
    },
    {
        "team": "U14",
        "liga": "Kreis Bonn",
        "link": "https://www.basketball-bund.net/static/#/liga/46329/tabelle",
        "img": basketball.path,
        "altText": basketball.altText
    },
]
export { badmintonSenioren, badmintonJunioren, basketballTeams }